
import React, { useEffect, useState, useContext } from "react";
import { getProducts } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"

const ProdListBut = ({ id_c, onSelect }) => {
    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            const result = await getProducts(id_c);
            setData(result);
        };
        fetchData();
    }, [id_c]);

    if (!data) return <p>{t('MList1')}</p>;

    return (

        <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      required
    >
      <option value="">-- {t("MList2") || "Selecciona una máquina"} --</option>
      {data.products.map((product) => (
        <option key={product.id_prod} value={product.id_prod}>
          {product.id_prod}
        </option>
      ))}
    </select>
  );
};

export default ProdListBut;